import React, {useState} from 'react';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../../config/design/styles";
import {Info, Utensils} from "lucide-react";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogContent, DialogTitle, Hidden, IconButton, Typography, useMediaQuery} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {truncate} from "../../../../../config/values";
import SubTitle from "../../../../components/elements/SubTitle";
import {theme} from "../../../../../config/design/theme";
import ShopHoursView from "../../../manage/shops/components/ShopHoursView";
import Grid from "@mui/material/Grid2";
import StaticMap from "../../../../components/address/map/StaticMap";
import {Link} from "react-router-dom";

function InfoButton({data,classes}) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    return (

        <div>
            {
                isMobile ?
                    <IconButton onClick={() => setOpen(true)}>
                        <Info className="lucide-large"/>
                    </IconButton>
                    :
                    <Button
                        startIcon={<Info className="lucide-small"/>}
                        onClick={() => setOpen(true)}
                    >
                        {t('info')}
                    </Button>
            }

            <Dialog fullWidth maxWidth="sm" open={open} onClose={() => setOpen(false)}>
                <DialogTitle>
                    <SubTitle component="span" align="left" className="dialog-title">{data.name}</SubTitle>
                    <IconButton
                        onClick={() => setOpen(false)}
                        size="small"
                        className={classes.dialogClose}
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <ShopHoursView timing={data.timing}/>
                        </Grid>
                        {
                            !!data.address?.lat &&
                            <Grid item size={12}>
                                <StaticMap
                                    height={200}
                                    coordinates={{lat:data.address?.lat,lng:data.address?.lng}}
                                    no_zoom
                                />
                            </Grid>
                        }
                        {
                            data.categories?.length > 0 &&
                            <Grid item size={12}>
                                <div className='category'>
                                    <Utensils className="lucide-small lucide-icon-gray" />
                                    <div className="category-holder">
                                        {
                                            data.categories.map((category, index) => (
                                                <React.Fragment key={index}>
                                                    <Link to={`${data.industry.name}/discover?categories=${category.id}`}>
                                                        {category.name}
                                                    </Link>
                                                    {(index + 1) < data.categories?.length && <b className="dot"> • </b>}
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                </div>
                            </Grid>
                        }

                        <Grid item size={12}>
                            <Typography>{data.description}</Typography>
                        </Grid>

                    </Grid>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default withStyles(Styles)(InfoButton);
